import { Card } from '../components/Card'
import { Button } from '../components/Button'
import { ProgressBar } from '../components/ProgressBar'
import { EmptyState } from '../components/EmptyState'
import { PageContainer } from '../components/PageContainer'
import { progressRepository } from '../../persistence/progressRepository'
import { buildLearningPathView } from '../viewModels/learningPath'
import styles from './TodayScreen.module.css'

/**
 * Today: the current lesson and resume state. Shows a single dominant action —
 * resume or start the active lesson — plus the learner's position in the path.
 */
export function TodayScreen() {
  const path = buildLearningPathView(progressRepository.load())
  const lesson = path.current

  return (
    <PageContainer title="Today" lede={path.name}>
      {lesson ? (
        <Card>
          <p className={styles.eyebrow}>
            Lesson {lesson.order} of {path.total} · about {lesson.estimatedMinutes} min
          </p>
          <h2 className={styles.lessonTitle}>{lesson.title}</h2>
          <p className={styles.lessonSummary}>{lesson.summary}</p>
          <div className={styles.action}>
            <Button variant="primary" to={`/lesson/${lesson.id}`}>
              {path.currentActionLabel} lesson
            </Button>
          </div>
        </Card>
      ) : (
        <Card>
          <EmptyState
            title="You've reached the end of this path"
            description="Every lesson in this path is complete. Revisit any of them from the Library."
            action={
              <Button variant="secondary" to="/library">
                Go to Library
              </Button>
            }
          />
        </Card>
      )}

      <Card>
        <h3 className={styles.progressHeading}>Your progress</h3>
        <ProgressBar
          value={path.completedCount}
          max={path.total}
          label={`${path.name} progress`}
        />
      </Card>
    </PageContainer>
  )
}
